// import { getUserInfo, openTenant } from '@/api/oauth2/user'
import { get } from '@/api/platform/system/store'

// import { getUserInfo, switchUser, exitSwitchUser, openUser, openTenant } from '@/api/oauth2/user'
import Utils from '@/utils/util'

export default {
  namespaced: true,
  state: {
    // 门店信息
    store: {}
  },
  actions: {
    /**
     * @description 设置用户数据
     * @param {Object} context
     * @param {*} info info
     */
    set({ state, dispatch }, store) {
      return new Promise(async resolve => {
        // store 赋值
        state.store = store
        // 持久化
        await dispatch('ibps/db/set', {
          dbName: 'sys',
          path: 'store.info',
          value: store,
          user: false
        }, { root: true })
        // end
        resolve()
      })
    },
    /**
     * @description 从数据库取用户数据
     * @param {Object} state vuex state
     */
    get({ state, dispatch }) {
      return new Promise(async resolve => {
        // store 赋值
        state.store = await dispatch('ibps/db/get', {
          dbName: 'sys',
          path: 'store.info',
          defaultValue: {},
          user: false
        }, { root: true })
        // end
        resolve()
      })
    },
    /**
     * @description 从数据库取门店数据
     * @param {Object} context
     */
    load({ state, dispatch }, id) {
      // console.log('load')
      return new Promise(async(resolve, reject) => {
        get(id).then(async response => {
          if (!response) {
            reject(response)
          }

          // 设置当前
          await dispatch('set', response.data)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}
